export enum CalendarLayout {
    MiniCarousel = 'MiniCarousel',
    Stacked = 'Stacked',
    TilesCarousel = 'TilesCarousel',
}

export enum CalendarPage {
    Featured = 'Featured',
    Competitions = 'Competitions',
    SportsCalendar = 'SportsCalendar',
    LiveCalendar = 'LiveCalendar',
    AtozSports = 'AtozSports',
}
